export enum Menus {
  period = 'period',
  profile = 'profile',
  accounts = 'accounts',
}

export type Period = [Date | null, Date | null]
